export enum ProductType {
    ShineAI = 'Shine AI',
    ShineEnrich = 'Shine Enrich',
    ShineConnect = 'Shine Connect',
    ShinePerformance = 'Shine Performance',
    ShineWebinars = 'Shine Webinars',
    ShineTranslations = 'Shine Translations'
}

export interface IClientOptions {
    id: string;
    name: string;
    logo: string;
    description: string;
    domain: string;
    enabledProducts: string[]; // Array of enabled products for this client
    conversationRetentionDays?: number | null;
}

export interface IApiKeyOptions {
    id: string;
    name: string;
    clientId: string;
    createdAt?: string;
    expiresAt?: string;
    permissions?: string[];
    isActive?: boolean;
    key?: string;
}
